import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { SendEmailResponseSchema } from '../email/email-response.schema';
import { EmailDraftSchema } from './draft.schema';

export const SendDraftResponseSchema = SendEmailResponseSchema;

export const GetDraftResponseSchema = EmailDraftSchema;

export const GetDraftsListResponseSchema = ListResponseSchema(EmailDraftSchema);

export const CreateDraftResponseSchema = EmailDraftSchema;

export const UpdateDraftResponseSchema = EmailDraftSchema;

export const DeleteDraftResponseSchema = Type.Null();

export type SendDraftResponse = Static<typeof SendDraftResponseSchema>;
export type GetDraftsListResponse = Static<typeof GetDraftsListResponseSchema>;
export type CreateDraftResponse = Static<typeof CreateDraftResponseSchema>;
export type GetDraftResponse = Static<typeof GetDraftResponseSchema>;
export type DeleteDraftResponse = Static<typeof DeleteDraftResponseSchema>;
export type UpdateDraftResponse = Static<typeof UpdateDraftResponseSchema>;
